import type React from "react";

type ImpactStat = {
  value: string;
  label: string;
  description?: string;
};

type ImpactStatsProps = {
  id?: string;
  stats: ImpactStat[];
};

const ImpactStats: React.FC<ImpactStatsProps> = ({ id, stats }) => {
  if (stats.length === 0) {
    return null;
  }

  return (
    <section id={id} className="bg-primary-50 py-16">
      <div className="container">
        <div className="mb-10 max-w-2xl">
          <h2 className="text-3xl font-semibold text-primary-900">
            Measuring our impact
          </h2>
          <p className="mt-4 text-base text-primary-800/80">
            We are establishing the baseline metrics that will help demonstrate
            tangible progress as programs grow.
          </p>
        </div>
        <div className="grid gap-8 md:grid-cols-3">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-2xl border border-primary-200 bg-white p-6 shadow-sm"
            >
              <div className="text-3xl font-semibold text-primary-900">
                {stat.value}
              </div>
              <div className="mt-2 text-lg font-medium text-primary-700">
                {stat.label}
              </div>
              {stat.description ? (
                <p className="mt-3 text-sm text-primary-700/80">
                  {stat.description}
                </p>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImpactStats;
